export const INCORPORATION_DATE_VALIDATION_MSG =
  'Group must have been in business a minimum of 12 months prior to requested policy effective date.';

export const INCORPORATION_DATE_GUIDELINES =
  'The official legal, tax, and regulatory start of a company. It verifies the existence of a registered organization such as an LLC or Corporation.';

/** True when incorporationDate is at least 12 months before effectiveDate. */
export function isIncorporationDateValid(incorporationDateValue: string, effectiveDateValue: string): boolean {
  if (!incorporationDateValue || !effectiveDateValue) {
    return false;
  }

  const incorporationDate = new Date(incorporationDateValue);
  const effectiveDate = new Date(effectiveDateValue);
  effectiveDate.setFullYear(effectiveDate.getFullYear() - 1);

  return incorporationDate <= effectiveDate;
}
